//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'pieChart',
  props: ['chart'],
  methods: {
    initPieChart: function initPieChart(data, type) {
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [{
          name: 'pie',
          type: 'pie',
          radius: [30, 80],
          center: ['50%', '55%'],
          roseType: 'area',
          data: [{
            value: 10,
            name: 'rose1'
          }, {
            value: 5,
            name: 'rose2'
          }, {
            value: 15,
            name: 'rose3'
          }, {
            value: 25,
            name: 'rose4'
          }, {
            value: 20,
            name: 'rose5'
          }, {
            value: 35,
            name: 'rose6'
          }, {
            value: 30,
            name: 'rose7'
          }, {
            value: 40,
            name: 'rose8'
          }]
        }]
      };

      if (type == 'radius') {
        option.visualMap = {
          show: false,
          min: 1,
          max: 100,
          inRange: {
            colorLightness: [0, 1]
          }
        };
        option.series = [{
          name: '站点类型',
          type: 'pie',
          radius: '55%',
          center: ['50%', '50%'],
          data: data.seriesData,
          roseType: 'radius',
          label: {
            color: '#fff'
          },
          labelLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          },
          itemStyle: {
            color: '#c23531',
            shadowBlur: 200,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          },
          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: function animationDelay(idx) {
            return Math.random() * 200;
          }
        }];
      }

      if (type == 'pie') {
        option.legend = {
          width: '100%',
          orient: 'vertical',
          right: 'right',
          data: data.legendData,
          textStyle: {
            color: '#fff'
          }
        };
        option.series = [{
          name: '工程类型',
          type: 'pie',
          label: {
            color: '#fff'
          },
          radius: '55%',
          center: ['50%', '60%'],
          data: data.seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }];
      }

      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};